import React, { Component } from "react";
import Dialog from "../dialog";
import DialogInput from "../input";
import DialogInputBox from "../inputbox";
import LanguageInput from "../languagesinput";
import GraphVideo from "./graphvideo/graphvideo";

import { getCurrentUserDatas } from "../../../utils/software";
import { apiReadOneVideo } from "../../../utils/apis";
import { V2_recfps } from "../../../utils/timecodev2";
class EditVideo extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        en:"Edit a video file", 
        fr:"Modifier un fichier vidéo",
      };
    this.state.title = title;
    this.state.tobecenter = true;

    this.state.buttons = 
    [
      //{type:"text", disabled:true,text:{fr:"Accepter",en:"Accept"},key:"accept"},
      {type:"text", disabled:false,text:{fr:"Graphe",en:"Graph"}, key:"graph"},
      {type:"back", disabled:false},
      {type:"ok", disabled:false},
      
    ]

    this.state.formulaire = 
      {
        asid: this.props.asset.asid,
        viid: this.props.asset.asviid,
        title: this.props.asset.astitle,
        convert: false,
        audio: false,
        cp: false,
        transcription: false,
        texts: false,
        simp: false,
        sce: false,
        filename: "",
        iduser: getCurrentUserDatas().id,
        audio1lang: "",
        audio2lang: "",
        audio1codec:"",
        audio2codec:"",
        audio1format:"",
        audio2format:"",
        nbaudio: 1,
        timecode: "",
        framerate:"",
        duration:"",
        videoformat:"",
        videocodec:"",
        timecodeori:"",

      }
   

      this.state.displaygraph = false;

    this.handleButton =  this.handleButton.bind(this);

    this.videoReadCallBack = this.videoReadCallBack.bind(this);


      this.titleRef = React.createRef();
      this.convertRef = React.createRef();
      this.audioRef = React.createRef();
      this.cpRef = React.createRef();
      this.transcriptionRef = React.createRef();
      this.textsRef = React.createRef();
      this.simpRef = React.createRef();
      this.sceRef = React.createRef();

      this.filenameRef = React.createRef();

      this.durationRef = React.createRef();
      this.framerateRef = React.createRef();

      this.timecodeRef = React.createRef();
      this.timecodeoriRef = React.createRef();

      this.videoformatRef = React.createRef();
      this.videocodecRef = React.createRef();
 
      this.audio1langRef = React.createRef();
      this.audio2langRef = React.createRef();

      this.handleOnChange = this.handleOnChange.bind(this);

      this.onQuit = this.onQuit.bind(this)
      this.onValid = this.onValid.bind(this)
      this.endDisplayGraph = this.endDisplayGraph.bind(this);

      this.didMount = false;

   
    
  }


  componentDidMount()
  {

    // lecture de la vidéo

    this.didMount=true;
    super.componentDidMount();

    apiReadOneVideo ({viid: this.props.asset.asviid}, this.videoReadCallBack)
  }

  videoReadCallBack(datas)
  {
    console.log("Video read call back ", datas)
    if (!Array.isArray(datas)) 
      this.onQuit();
    else
    {
        // on a retrouvé la 7eme compagnie
        if (datas.length ===0)
          this.onQuit();
        else
        {
            var video = datas[0];


            var formulaire = this.state.formulaire;
            

            this.filenameRef.current.setValue(video.viorifile);
            formulaire.convert = (video.viconv != -2); 
            formulaire.audio = (video.vixaudio != -2);
            formulaire.cp = (video.vixcp != -2);
            formulaire.transcription = (video.vixtr != -2);
            formulaire.texts = (video.vixtex != -2);           
            formulaire.sce = (video.visce != -2);           
            formulaire.simp = (video.visimp != -2);           



            this.convertRef.current.setValue(formulaire.convert)
            this.audioRef.current.setValue(formulaire.audio)
            this.cpRef.current.setValue(formulaire.cp)
            this.transcriptionRef.current.setValue(formulaire.transcription)
            this.textsRef.current.setValue(formulaire.texts)
            this.simpRef.current.setValue(formulaire.simp)
            this.sceRef.current.setValue(formulaire.sce)


            formulaire.nbaudio = video.vinbaudio;

            formulaire.timecode = video.vitimecode;
            formulaire.duration = video.viduration;
            formulaire.timecodeori = video.vitimecodeori;

            var framerate = video.viframerate.toFixed(2).replace('.', ','); // "1234,56"
            framerate = framerate + " (" + video.vinum+"/"+video.viden+")";

            const fps = V2_recfps(video.vinum,video.viden);
            if (fps == 29.97)
            {
              if (video.vidropframe === 1)
                framerate = framerate + " DF";
              else
                framerate = framerate + " NDF";
            }
            formulaire.framerate = framerate
            
            this.framerateRef.current.setValue(formulaire.framerate)
            this.durationRef.current.setValue(formulaire.duration)
            this.timecodeRef.current.setValue(formulaire.timecode)
            this.timecodeoriRef.current.setValue(formulaire.timecodeori)

            formulaire.videoformat = video.viformatvideo;
            formulaire.videocodec = video.vicodecvideo;

            this.videoformatRef.current.setValue(formulaire.videoformat)
            this.videocodecRef.current.setValue(formulaire.videocodec)


            formulaire.audio1lang = video.viaudio1lang;
            formulaire.audio1codec = video.vicodecaudio1;
            formulaire.audio1format = video.viformataudio1;

            formulaire.audio2lang = video.viaudio2lang;
            formulaire.audio2codec = video.vicodecaudio2;
            formulaire.audio2format = video.viformataudio2;


            this.audio1langRef.current.setValue(
              formulaire.audio1lang,formulaire.audio1codec,formulaire.audio1format
            )
            if ((this.audio2langRef) && (this.audio2langRef.current))
            {
              this.audio2langRef.current.setValue(
                formulaire.audio2lang,formulaire.audio2codec,formulaire.audio2format
              )
            }
            this.setState({formulaire:formulaire})
      
            


            
        }


    }
  }

  onValid(datas)
  {
      console.log(this.state.formulaire)
  }

  onQuit()
  {
    this.props.onButton("back", this.state.formulaire);    
  }

  handleOnChange()
  {

      if (!this.didMount) return;
      var formulaire = this.state.formulaire;
      var changed = false;
      if (this.state.formulaire.title !== this.titleRef.current.getValue())
      {
          formulaire.title = this.titleRef.current.getValue();
          changed = true;
      }
      if (this.state.formulaire.convert !== this.convertRef.current.getValue())
      {
          formulaire.convert = this.convertRef.current.getValue();
          changed = true;
      }

      if (this.state.formulaire.audio !== this.audioRef.current.getValue())
      {
          formulaire.audio = this.audioRef.current.getValue();
          changed = true;
      }
      if (this.state.formulaire.cp !== this.cpRef.current.getValue())
      {
          formulaire.cp = this.cpRef.current.getValue();
          changed = true;
      }
      if (this.state.formulaire.transcription !== this.transcriptionRef.current.getValue())
      {
          formulaire.transcription = this.transcriptionRef.current.getValue();
          changed = true;
      }
            
      if (this.state.formulaire.texts !== this.textsRef.current.getValue())
      {
          formulaire.texts = this.textsRef.current.getValue();
          changed = true;
      }
  
      if (this.state.formulaire.audio1lang != this.audio1langRef.current.getValue())
      {
        formulaire.audio1lang = this.audio1langRef.current.getValue();
        changed = true;
      }

      if ((this.audio2langRef) && (this.audio2langRef.current))
      {
        if (this.state.formulaire.audio2lang != this.audio2langRef.current.getValue())
        {
          formulaire.audio2lang = this.audio2langRef.current.getValue();
          changed = true;
        }
      }  
      //this.state.formulaire.title = this.titleRef.current.getValue();
      //this.formulaire.convert = this.convertRef.current.getValue();
      //this.formulaire.audio = this.audioRef.current.getValue();
      //this.formulaire.cp = this.cpRef.current.getValue();
      //this.formulaire.transcription = this.transcriptionRef.current.getValue();
      //this.formulaire.texts = this.textsRef.current.getValue();


      if (changed)
      {
        if (formulaire.title.trim() != "")
            this.setDisabledButtonByType("ok", false);
        else
            this.setDisabledButtonByType("ok", true);


        this.setState({formulaire: formulaire})
        console.log("set state formulaire ", formulaire)
      }

      
      
  }


  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)

    if (buttonkey == "graph") 
    {
      this.cancelKey=true;
      this.setState ({displaygraph: true});
      return;
    }

    console.log(this.state.formulaire)
    this.props.onButton(buttonkey, this.state.formulaire);
  }

  endDisplayGraph ()
  {
    this.cancelKey=false;
    this.setState ({displaygraph: false});

  }

  render()
  {


    const audio1 =
    (
        <>
        <LanguageInput
                value = {this.state.formulaire.audio1lang}
                codec = {this.state.formulaire.audio1codec}
                format = {this.state.formulaire.audio1format}
                disabled={false}
                autoFocus = {false}
                ref = {this.audio1langRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "250px"
                title = {this.context.language=="fr"?"Audio 1":"Audio 1"}
              />
        </>

    )

    var audio2 = (<></>)
    if (this.state.formulaire.nbaudio > 1)
    {
      audio2 = (
        <>
        <div className="dialogSectionZone">
        <LanguageInput
                value = {this.state.formulaire.audio2lang}
                codec = {this.state.formulaire.audio2codec}
                format = {this.state.formulaire.audio2format}
                disabled={false}
                autoFocus = {false}
                ref = {this.audio2langRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "250px"
                title = {this.context.language=="fr"?"Audio 2":"Audio 2"}
              />
          </div>
        </>


      )
    }

    const div2 =
    (
        <>
          <div className="dialogSectionZone">
          <DialogInput
            value = {this.state.formulaire.videocodec}
            disabled={false}
            autoFocus = {true}
            title = {this.context.language=="fr"?"Codec Vidéo":"Video Codec"}
            width = "250px"
            ref = {this.videocodecRef}
            readOnly = {true}
            onChange =  {this.handleOnChange}
  
          />
  
        <br/>
        <DialogInput
            value = {this.state.formulaire.videoformat}
            disabled={false}
            autoFocus = {true}
            title = {this.context.language=="fr"?"Format Vidéo":"Video Format"}
            width = "250px"
            ref = {this.videoformatRef}
            readOnly = {true}
            align="center"
            onChange =  {this.handleOnChange} />
        <br/>
        </div>
        
        <div className="dialogSectionZone">
        {audio1}
        </div>
        {audio2}
      </>
    )
  

    const div1 =
    (
      <>
      <br/>
        <DialogInput
          value = {this.state.formulaire.title}
          disabled={false}
          autoFocus = {true}
          title = {this.context.language=="fr"?"Titre":"Title"}
          width = "250px"
          ref = {this.titleRef}
          onChange =  {this.handleOnChange}

        />

      <br/><br/>
      <div className = "dialogSectionZone">
      <DialogInputBox
                value = {this.state.formulaire.convert}
                disabled={true}
                autoFocus = {false}
                onChange =  {this.handleOnChange}
                ref = {this.convertRef}
                title = {this.context.language=="fr"?"Convertir en mp4":"Convert to MP4"}
              />
      <br/>
      <DialogInputBox
                value = {this.state.formulaire.audio}
                disabled={true}
                autoFocus = {false}
                ref = {this.audioRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Extraire les audios":"Extract Audio Tracks"}
              />
      <br/>
      <DialogInputBox
                value = {this.state.formulaire.cp}
                disabled={true}
                autoFocus = {false}
                ref = {this.cpRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Chercher les changements de plan":"Extract Shots"}
              />
      <br/>
      <DialogInputBox
                value = {this.state.formulaire.transcription}
                disabled={true}
                autoFocus = {false}
                ref = {this.transcriptionRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Extraire la transcription":"Extract transcription"}
              />
      <br/>
      <DialogInputBox
                value = {this.state.formulaire.simp}
                disabled={true}
                autoFocus = {false}
                ref = {this.simpRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Simplifier la transcription":"Use transcription simplifier"}
              />
      <br/>
      <DialogInputBox
                value = {this.state.formulaire.sce}
                disabled={true}
                autoFocus = {false}
                ref = {this.sceRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Utiliser un scénario":"Use scenario"}
              />
      <br/>
      <DialogInputBox
                value = {this.state.formulaire.texts}
                disabled={true}
                autoFocus = {false}
                ref = {this.textsRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Rechercher les textes dans l'image":"Look for on-screen texts"}
              />

      </div>
      <br/>
      <DialogInput
                value = {this.state.formulaire.filename}
                disabled={false}
                autoFocus = {false}
                ref = {this.filenameRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "250px"
                align="center"
                title = {this.context.language=="fr"?"Fichier original":"Original file"}
              />
        <br/>


      <DialogInput
                value = {this.state.formulaire.timecode}
                disabled={false}
                autoFocus = {false}
                ref = {this.timecodeRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "120px"
                align="center"
                title = {this.context.language=="fr"?"Time Code":"Time Code"}
              />

      <DialogInput
                value = {this.state.formulaire.timecodeori}
                disabled={false}
                autoFocus = {false}
                ref = {this.timecodeoriRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "120px"
                align="center"
                title = {this.context.language=="fr"?"Time Code Original":"Original Time Code"}
              />



      <DialogInput
                value = {this.state.formulaire.duration}
                disabled={false}
                autoFocus = {false}
                ref = {this.durationRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "120px"
                align="center"
                title = {this.context.language=="fr"?"Durée":"Duration"}
              />
      <DialogInput
                value = {this.state.formulaire.framerate}
                disabled={false}
                autoFocus = {false}
                ref = {this.framerateRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "190px"
                align="center"
                title = {this.context.language=="fr"?"Frame Rate":"Frame Rate"}
              />



      </>
    )
    var maxwidth =  (window.innerWidth * 60)/100;
    if (maxwidth > 600) maxwidth = 600;
    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 650) maxheight = 650;

    var graph = (<></>)
    if (this.state.displaygraph)
      graph = (<GraphVideo display = {this.state.displaygraph} 
        viid = {this.props.asset.asviid}
        zindex = {this.props.zindex + 2}
        onButton={this.endDisplayGraph}/>)

    return super.render(
  
    <>
    {graph}



      <div style = {{width:maxwidth, height: maxheight}}>
  
        <table style = {{width:maxwidth, height: maxheight}}>
          <tr>
            <td width="50%">
              {div1}
            </td>
            <td width="50%">
              {div2}
            </td>
            
          </tr>
      </table>
      </div>
     </>
    );
  }


}
EditVideo.defaultProps = 
{ 

}


export default EditVideo;